export default "__VITE_ASSET__dQBceYdg__";